'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _clear = require('./clear');

var _clear2 = _interopRequireDefault(_clear);

var _slice = require('./slice');

var _slice2 = _interopRequireDefault(_slice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'takeLast',
    immutable: 'takeLast',
    all: function all(amount) {
        return amount === 0 ? (0, _clear2.default)() : (0, _slice2.default)(-amount);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/takeLast.js
// module id = 909
// module chunks = 35783957827783